import { Controller } from 'stimulus'
import randomString from '../../common/random-string'

/**
 */
export default class extends Controller {
  static get targets() {
    return ['label', 'required', 'description', 'error', 'control']
  }

  connect() {
    if (!this.hasControlTarget) {
      console.error(
        'FormItem に内包されるフォームコントロールには data-target="form-item.control" 属性を付与してください。'
      )
      return
    }

    const labelId = randomString('FormItem-')
    const descriptionId = randomString('FormItem-')
    const errorId = randomString('FormItem-')
    let describedByIds = []

    if (this.hasLabelTarget) {
      this.labelTarget.id = labelId
    }
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.id = descriptionId
      describedByIds.push(descriptionId)
    }
    if (this.hasErrorTarget) {
      this.errorTarget.id = errorId
      describedByIds.push(errorId)
    }

    if (this.controlTargets.length > 1) {
      // 複数コントロールの場合、箱はグループである。
      this.element.setAttribute('role', 'group')
      this.element.setAttribute('aria-labelledby', labelId)
      this.element.setAttribute('aria-describedby', describedByIds.join(' '))
    } else {
      // 単数コントロールの場合、コントロールにラベルを付ける
      this.controlTarget.setAttribute('aria-labelledby', labelId)
      this.controlTarget.setAttribute(
        'aria-describedby',
        describedByIds.join(' ')
      )
      // 必須マークが付いている場合 aria-required 属性を付与する。
      // UI に影響させたくないので required 属性ではなく aria-required 属性としている。
      if (this.hasRequiredTarget) {
        this.controlTarget.setAttribute('aria-required', 'true')
      }
    }
  }
}
